import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
  },
  innerWrapper: {
    padding: theme.spacing(1),
  },
}));

export default useStyles;
